var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddBrand',{attrs:{"details":_vm.details,"update":false},on:{"saveDetail":_vm.saveBrand,"cancelCreate":_vm.cancelCreate}})
}
var staticRenderFns = []

export { render, staticRenderFns }